import axios from 'axios';
import ENV from '../constants/Environment.js';
export default new class VerseService {

    async getVOTD() {
        var today = new Date();
        var currentDay = Math.ceil((today - new Date(today.getFullYear(),0,1)) / 86400000);
        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/votd/${currentDay}`);
        return response.data.results;
    }

    async getVerse(pBook, pChapter, pVerse, pVersion) {
        const response = await axios.get(`${ENV.HEROKU_API_ENDPOINT}/assets/bible/${pVersion}/${pBook}.json`);

        if (pVerse.indexOf("-") > -1) {
            var verseResponse = "";
            pVerse = pVerse.split("-");

            for (var i = parseInt(pVerse[0]); i <= parseInt(pVerse[1]); i++) {
                verseResponse += response.data.book.chapters[parseInt(pChapter)-1].verses[i-1].text + " ";
            }
            return verseResponse;
        }
        return response.data.book.chapters[parseInt(pChapter) - 1].verses[pVerse - 1].text;
    }

    async subscribe(pSubscribe) {
        // var today = new Date();
        // var currentDay = Math.ceil((today - new Date(today.getFullYear(),0,1)) / 86400000);
        // pSubscribe.d = currentDay;
        // const options = {
		// 	method: 'POST',
		// 	headers: { 'content-type': 'application/x-www-form-urlencoded' },
		// 	data: pSubscribe,
		// 	url: `${ENV.API_ENDPOINT}/bible/subscribe.php`,
		// };
		// const response = await axios(options);
        // return response.data;

        var today = new Date();
        var currentDay = Math.ceil((today - new Date(today.getFullYear(),0,1)) / 86400000);
        const options = {
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			data: {
				"name": pSubscribe.Name,
				"phone": pSubscribe.Phone,
				"image": pSubscribe.Image,
                "verse": pSubscribe.Verse,
                "day": currentDay
			},
			url: `${ENV.HEROKU_API_ENDPOINT}/votd/subscribe`,
		};

        try {
			const response = await axios(options);
			return {
				statusCode: response.status,
				results: response.data.results
			}
		} catch (error) {
			return {
				statusCode: error.response.status,
				results: error.response.data
			}
        }
    }

}
